// SelectionChip component generated from Figma node 362:3426
// Design tokens: primary/primary-40%: #C5ABFA, primary/primary: #6D2EF2, gray scale/white: #FFFFFF
// Asset URLs expire in 7 days
import React from "react";

// Pure CSS line separator for SelectionChip

type LineSeparatorProps = {
  actived?: boolean;
};

function LineSeparator({ actived }: LineSeparatorProps) {
  return (
    <div
      style={{
        height: 12,
        width: 1,
        background: actived ? "#fff" : "#c5abfa",
        borderRadius: 0.5,
        flexShrink: 0,
      }}
    />
  );
}

export interface SelectionChipProps
  extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md";
  state?: "default" | "actived";
  labels?: string[];
}

export default function SelectionChip({
  size = "sm",
  state = "default",
  labels = ["Label"],
  className,
  ...props
}: SelectionChipProps) {
  const fontWeight = state === "default" ? 600 : 700;
  const textColor = state === "default" ? "#c5abfa" : "#fff";
  const fontFamily = "'Pretendard', 'sans-serif'";
  const dataName = `size=${size}, labels=${labels.length}, state=${state}`;

  // Tailwind classes for layout and static styles
  const baseClass = [
    "flex items-center justify-center overflow-hidden w-fit",
    size === "md" ? "h-9 rounded-[18px] px-5" : "h-8 rounded-[16px] px-4",
    "gap-1",
  ].join(" ");
  // Dynamic border/background
  const borderClass =
    state === "actived"
      ? "border border-[transparent] border-solid"
      : "border border-[#c5abfa] border-solid";
  const bgClass = state === "actived" ? "bg-[#6d2ef2]" : "bg-transparent";

  return (
    <div
      className={`${baseClass} ${borderClass} ${bgClass} ${className}`}
      data-name={dataName}
      {...props}
    >
      {labels.map((label, idx) => (
        <React.Fragment key={idx}>
          {idx > 0 && <LineSeparator actived={state === "actived"} />}
          <span
            className={`text-center text-[14px] leading-[14px] tracking-[-0.28px] whitespace-nowrap mt-1 ${
              fontWeight === 700 ? "font-bold" : "font-semibold"
            }`}
            style={{ fontFamily, color: textColor }}
          >
            {label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
